export const addWishItem = (item) => ({
    type: 'ADD_WISH_ITEM',
    payload: item
});